<template>
    
  <toast position="bottom-right" />

	<div :class="containerClass" @click="onWrapperClick">
        <AppTopBar />
    
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>
        
        <div class="layout-main-container">
  
            <div class="layout-main" style="position:relative">
              <!-- <breadcrumb :home="breadcrumb.menu.home" :model="breadcrumb.menu.items" />  -->
              
              <router-view /> <!-- router-view -->
            </div>
            <AppFooter />
        </div>

		<AppConfig :layoutMode="layoutMode" :layoutColorMode="layoutColorMode" @layout-change="onLayoutChange" @layout-color-change="onLayoutColorChange" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import roles from '@/config/roles'


export default {
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
    },
    data() {
        return {
            loading: false,
            pageName: '',
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu : [
                {
                  items: [
                      {label: 'RCU', icon: 'pi pi-file', to: '/caricamentoRcu', visibility:[roles.admin.role]}, 
                      {label: 'RCU Upload', icon: 'pi pi-file', to: '/UploadRcu', visibility:[roles.admin.role]}, 
                      {label: 'RCU Info', icon: 'pi pi-file', to: '/InfoRcu', visibility:[roles.admin.role]}, 
                      {label: 'Letture', icon: 'pi pi-file', to: '/CaricamentoLetture', visibility:[roles.admin.role]}, 
                      {label: 'Flussi Caricati', icon: 'pi pi-file', to: '/flussiCaricati', visibility:[roles.admin.role]},     
                      {label: 'Flussi Ore', icon: 'pi pi-file', to: '/flussiOre', visibility:[roles.admin.role]},     
                      {label: 'Fornitori', icon: 'pi pi-file', to: '/CaricamentoFileFornitori', visibility:[roles.admin.role]},
                      {label: 'Fatture Fornitori Grezze', icon: 'pi pi-file', to: '/FattureFornitoriGrezze', visibility:[roles.admin.role]},
                      { label: 'Fatture Pratiche', icon: 'pi pi-euro', to: '/fatture-pratiche', visibility: [roles.admin.role] },
                      {label: 'SwitchOut', icon: 'pi pi-file', to: '/CaricamentoSwitchOut', visibility:[roles.admin.role]}, 
                      {label: 'SwitchIn', icon: 'pi pi-file', to: '/CaricamentoSwitchIn', visibility:[roles.admin.role]},
                      {label: 'VT4', icon: 'pi pi-file', to: '/CaricamentoVT4', visibility:[roles.admin.role]},  
                      {label: 'Annullamento Pratica', icon: 'pi pi-file', to: '/CaricamentoAnnullamentoPratica', visibility:[roles.admin.role]},     
                      {label: 'Sospensioni/Riattivazioni', icon: 'pi pi-file', to: '/SospensioniERiattivazioni', visibility:[roles.admin.role]},     
                      {label: 'Log Fatture Agyo', icon: 'pi pi-file', to: '/LogFattureAgyo', visibility:[roles.admin.role]},     
                      {label: 'SendGrid', icon: 'pi pi-envelope', to: '/SendGridLog', visibility:[roles.admin.role]},     
                      {label: 'Sincronizzazione', icon: 'pi pi-file', to: '/databaseSyncLogs', visibility:[roles.admin.role]},
                      {label: 'Sincronizzazione (beta)', icon: 'pi pi-cog', to: '/databaseSyncConf', visibility:[roles.admin.role]},
                      {label: 'Sync Log (beta)', icon: 'pi pi-list', to: '/databaseSyncJobLogs', visibility:[roles.admin.role]},
                      {label: 'Arera', icon: 'pi pi-file', to: '/Arera', visibility:[roles.admin.role]},
                      {label: 'Morosità', icon: 'pi pi-file', to: '/morosita', visibility:[roles.admin.role]},
                      {label: 'Caricamento File Per Cmor', icon: 'pi pi-file', to: '/cmor', visibility:[roles.admin.role]},
                      {label: 'Versioni documenti', icon: 'pi pi-file', to: '/versioni-documenti', visibility:[roles.admin.role]},

                      { label: 'SMS Templates', icon: 'pi pi-envelope', to: '/sms', visibility: [roles.admin.role] },
                      { label: 'PUN ORARIO', icon: 'pi pi-chart-line', to: '/caricamentoPun', visibility: [roles.admin.role] },
                      { label: 'TEAMSYSTEM BILANCI', icon: 'pi pi-chart-bar', to: '/caricamento-teamsystem', visibility: [roles.admin.role] },
                      { label: 'Export Contabilità', icon: 'pi pi-wallet', to: '/export-contabilita', visibility: [roles.admin.role] },
                      { label: 'Stato Server Allianz', icon: 'pi pi-desktop', to: '/allianz-status', visibility: [roles.admin.role] }
                  ]
                },
            ],
            breadcrumb:{
                menu:{
                    home: {icon: 'pi pi-fw pi-home', to: '/'},
                     items: [
                        {label: 'Dashboard'},
                    ]          
                }
            },
        }
    },
   
    created(){

    
 
    this.$eventBus.on('page-change', (evt) => {       
        this.breadcrumb.menu.items = [{label: evt.currentRoute.name}]
    })

    this.$eventBus.on('data-loading', () => { 
        // this.loading = true
    })
    this.$eventBus.on('data-loaded', () => { 
        // this.loading = false
    })
    this.$eventBus.on('data-load-success', (evt) => {
      this.$toast.add({
        severity:'success', 
        summary: 'Successo', 
        detail: `${evt.message}`, 
        life: 4000
      })
    //   this.loading = false
    })

    this.$eventBus.on('data-load-error', (evt) => {
      this.$toast.add({
        severity:'warn', 
        summary: 'Error Message', 
        detail: `message: ${evt.message} url: ${evt.url}`, 
        life: 4000
      })
    //   this.loading = false
    })


    this.$eventBus.on('menu-toggle', (event) => {
        this.menuClick = true;
        if (this.isDesktop()) {
            if (this.layoutMode === 'overlay') {
                if(this.mobileMenuActive === true) {
                    this.overlayMenuActive = true;
                }

                this.overlayMenuActive = !this.overlayMenuActive;
                this.mobileMenuActive = false;
            }
            else if (this.layoutMode === 'static') {
                this.staticMenuInactive = !this.staticMenuInactive;
            }
        }
        else {
          this.mobileMenuActive = !this.mobileMenuActive;
        }

        event.preventDefault();
    })


  },
  
  /////// BEGIN THEME
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    methods: {
      onWrapperClick() {
        if (!this.menuClick) {
          this.overlayMenuActive = false;
          this.mobileMenuActive = false;
        }

        this.menuClick = false;
      },

      onSidebarClick() {
        this.menuClick = true;
      },

      onMenuItemClick(event) {
        if (event.item && !event.item.items) {
            this.overlayMenuActive = false;
            this.mobileMenuActive = false;
        }
      },

      onLayoutChange(layoutMode) {
        this.layoutMode = layoutMode;
      },

      onLayoutColorChange(layoutColorMode) {
        this.layoutColorMode = layoutColorMode;
      },

      addClass(element, className) {
          if (element.classList)
              element.classList.add(className);
          else
              element.className += ' ' + className;
      },

      removeClass(element, className) {
          if (element.classList)
              element.classList.remove(className);
          else
              element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      },

      isDesktop() {
          return window.innerWidth >= 992;
      },

      isSidebarVisible() {
          if (this.isDesktop()) {
              if (this.layoutMode === 'static')
                  return !this.staticMenuInactive;
              else if (this.layoutMode === 'overlay')
                  return this.overlayMenuActive;
          }

          return true;
      }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
               'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false,
                'layout-theme-light': this.$appState.theme.startsWith('saga'),
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    
}
</script>

<style lang="scss">
// @import './App.scss';
.p-breadcrumb{
    margin-bottom: 20px;
}
</style>
